import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { freshmanProcess } from "../../constants/apiUrl";
import { IFreshManSubStepPercentage, IFreshmanProcessVersion, IMainStepConfiguration, ISubStepConfiguration } from "../../models/freshman/freshmanProcess";

export default new (class FreshmanProcessService {
  public getAllMainStepPercentage = async (): Promise<IApiResponse<Array<IMainStepConfiguration>>> => {
    try {
      let endPoint = freshmanProcess.GET_ALL_MAINSTEP_PERCENTAGE;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IMainStepConfiguration>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IMainStepConfiguration>>;
      } else {
        throw error;
      }
    }
  };

  public getSubStepsByMainStepId = async (
    id: number
  ): Promise<IApiResponse<ISubStepConfiguration>> => {
    try {
      let endPoint = urlBinder(freshmanProcess.GET_SUBSTEP_BY_MAINSTEP_ID, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ISubStepConfiguration>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ISubStepConfiguration>;
      } else {
        throw error;
      }
    }
  };
  public updateSubStepPercentage = async (
    data: IFreshManSubStepPercentage
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = freshmanProcess.UPDATE_FRESHMAN_SUBSTEP_PERCENTAGE;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public getFreshmanProcessVersion = async (): Promise<IApiResponse<IFreshmanProcessVersion>> => {
    try {
      let endPoint = freshmanProcess.GET_FRSHMAN_PROCESS_VERSION;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IFreshmanProcessVersion>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IFreshmanProcessVersion>;
      } else {
        throw error;
      }
    }
  };
})();
